import React from "react";
import { Card, Divider, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import PreviewBulkScan from "../../../components/Comman/BulkInwardOutward/PreviewBulkScan";
import BinLocationService from "../../../services/Wash-service/BinLocationService";
import "../../../styles/global-ui.css";

const Wash_BulkOutwardPreviewPage = () => {
  const navigate = useNavigate();

const handleConfirmBinOutward = async (formatedBinId, addedBy) => {
  try {
    const response = await BinLocationService.bulk_bin_movement(
      formatedBinId,
      addedBy,
      "washing",
      "garment_super_market",
      "outward"
    );

    console.log("Response:", response);

    // ✅ navigate only on success
    if (response?.status === "success" || response?.status === true) {
      navigate(-1);
    }

    return response;

  } catch (error) {
    console.error("Error during bin movement:", error);
    throw error;
  }
};

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            <span className="page-title-inline">
              <ArrowLeftOutlined
                className="page-back-icon"
                onClick={() => navigate(-1)}
              />
              Bulk Outward Preview
            </span>
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Review selected bins before confirming outward movement
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <PreviewBulkScan
          handleConfirmBinInward={handleConfirmBinOutward}
          type="outward"
          title="Bulk Outward Preview"
        />
      </Card>
    </div>
  );
};

export default Wash_BulkOutwardPreviewPage;